document.addEventListener("DOMContentLoaded", function () {
  const testimonialsPdp = document.querySelector(
    ".testimonials-users__wrapper-pdp"
  );

  if (testimonialsPdp) {
    const swiper = new Swiper(testimonialsPdp, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      breakpoints: {
        749: {
          slidesPerView: 2,
        },
        989: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
});
